"use client";

import { useEffect } from "react";

/**
 * Registers the PWA service worker in production only.
 * In development, unregisters workers and clears caches so stale /_next/static/
 * chunks cannot cause React hydration mismatches after hot reloads.
 */
export function ServiceWorkerLifecycle() {
  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

    if (process.env.NODE_ENV !== "production") {
      void navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => void r.unregister());
      });
      if ("caches" in window) {
        void caches.keys().then((keys) => {
          keys.forEach((key) => void caches.delete(key));
        });
      }
      return;
    }

    navigator.serviceWorker.register("/sw.js").catch(() => {});
  }, []);

  return null;
}
